import { Guid } from 'guid-typescript';

export class SubscriptionDetailModel {
  id: Guid;
  isActive: boolean;
  startDate: string;
  endDate: string;
  note: string;
}
